import { msalInstance } from '../constants/login/msalInstance';

export const isAzureAccount = msalInstance.getAllAccounts()[0];
